import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import { GridColDef } from "@mui/x-data-grid";
import React, { useState } from "react";
import NewButton from "../../components/Buttons/NewButton";
import SearchButton from "../../components/Buttons/SearchButton";
import CommonPagination from "../../components/CustomPagination/CommonPagination";
import CommonTable from "../../components/CustomTable/CommonTable";
import { Title } from "../../components/Desc";
import ProgressIndicator from "../../components/ProgressIndicator";
import strings from "../../config/localization";
import { useGetAllTemplatesQuery } from "../../services/appln";
import { getRowsPerPage } from "../constants";
import { doesPermissionExist } from "../util";
import EditPersonnelTemplate from "./EditPersonnelTemplate";
import NewPersonnelTemplate from "./NewPersonnelTemplate";
import DeletePersonnelTemplate from "./DeletePersonnelTemplate";
import { Stack } from "@mui/material";
import BasicMenu from "../../components/menu/BasicMenu";

export default function ListPersonnelTemplates() {
  const [pageNo, setPageNo] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(getRowsPerPage());

  const [searchTerm, setSearchTerm] = React.useState("");

  const [newDialogOpen, setNewDialogOpen] = React.useState(false);

  const getParams = {
    page: pageNo,
    limit: rowsPerPage,
    search: searchTerm,
  };

  const designationsQueryResponse = useGetAllTemplatesQuery(getParams);

  const columns: GridColDef[] = [
    {
      field: "serialNo",
      headerName: strings.serialNo,
      width: 150,
    },
    {
      field: "name",
      headerName: strings.name,
      width: 200,
    },
    {
      field: "organizationName",
      headerName: strings.organization,
      width: 200,
    },
    {
      field: "assessments",
      headerName: strings.assessments,
      width: 600,
      renderCell: (params: any) => {
        return (
          <>
            {params.row.assessments
              .toSorted((x: any, y: any) => {
                return x.designationName.localeCompare(y.designationName);
              })
              .map((e: any) => {
                return `${e.designationName}:${e.count}`;
              })
              .join(", ")}
          </>
        );
      },
    },
  ];

  if (
    doesPermissionExist("update-personnel") ||
    doesPermissionExist("delete-personnel")
  ) {
    columns.push({
      field: "menu",
      headerName: "",
      width: 150,
      renderCell: (params: any) => {
        const options = [
          [
            null,
            <Stack direction={"column"} spacing={1}>
              {doesPermissionExist("update-personnel-assessment-template") && (
                <EditPersonnelTemplate id={params.id} initialValues={params} />
              )}
              {doesPermissionExist("delete-personnel-assessment-template") && (
                <DeletePersonnelTemplate id={params.id} />
              )}
            </Stack>,
            null,
            "locations",
            "action",
          ],
        ];
        return (
          <BasicMenu
            action={strings.actions}
            options={options}
            data={params.row}
            type="bandobast"
          />
        );
      },
    });
  }

  const handleChangePage = (event: any, value: any) => {
    setPageNo(value);
  };

  const handleChangeCount = (e: any) => {
    setRowsPerPage(e.target.value);
  };

  return (
    <div>
      <Box sx={{ height: 400, width: "100%" }}>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Title text={strings.templates} />
          </Grid>
          {(designationsQueryResponse.isLoading ||
            designationsQueryResponse.isFetching) && <ProgressIndicator />}
          {doesPermissionExist("create-personnel-assessment-template") ? (
            <>
              <Grid item xs={2}>
                <div>
                  <NewButton
                    onClickHandler={() => {
                      setNewDialogOpen(true);
                    }}
                  />
                  <NewPersonnelTemplate
                    onSubmitHandler={(newObj: any) => {
                      setNewDialogOpen(false);
                    }}
                    onCancelHandler={() => {
                      setNewDialogOpen(false);
                    }}
                    state={newDialogOpen}
                  />
                </div>
              </Grid>
              <Grid item xs={10}>
                <SearchButton
                  onClickHandler={(searchTerm: string) => {
                    setSearchTerm(searchTerm);
                  }}
                />
              </Grid>
            </>
          ) : (
            <Grid item xs={12}>
              <SearchButton
                onClickHandler={(searchTerm: string) => {
                  setSearchTerm(searchTerm);
                }}
              />
            </Grid>
          )}
          <Grid item xs={12}>
            <div>
              <CommonTable
                rows={
                  designationsQueryResponse.data
                    ? designationsQueryResponse.data?.data
                    : []
                }
                columns={columns}
              />
              <CommonPagination
                count={Math.ceil(
                  designationsQueryResponse.data?.totalCount / rowsPerPage,
                )}
                page={pageNo}
                handleChangePage={handleChangePage}
                rowPerPage={rowsPerPage}
                handleChangeCount={handleChangeCount}
              />
            </div>
          </Grid>
        </Grid>
      </Box>
    </div>
  );
}
